import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import type { TaxonomyEntry } from 'src/redux/content/types';
import { selectResolvedPathname } from 'src/redux/navigation/selectors';
import { selectTaxonomyContentEntry } from 'src/utils/selectTaxonomyContentEntry';

export const selectMatchedTaxonomyEntry = (state: ReduxApplicationState): TaxonomyEntry | null =>
  selectTaxonomyContentEntry(selectResolvedPathname(state), state.content.entries ?? []);
